<template>
  <div class="content-tree sys-center-zuzhijigou">
    <lr-tree :data="treeData" @setTreeWidth="setTreeWidth" :width="width" :loading="treeLoading" :ref="treeBindRef"
      :bindRef="treeBindRef" nodeKey="ID" :title="treeTitle" @nodeClick="nodeClick" :defaultProps="defaultProps">
    </lr-tree>
  </div>
</template>

<script>
  import {
    getWebSiteDeptTree,
    getMineDeptTree,
    getMyDeptTree,
    GetAuthOrgan,
    GetALLOrgan
  } from "@/api/organization";
  export default {
    name: "DeptTree",
    props: {
      //1:页面权限树，2：站点机构树,3：只有权限下的井工矿,4 获取当前用户组织机构树结构视图
      DeptType: {
        type: Number,
        default: 1,
        reqired: true,
      },
      width: {
        type: String,
        default: "200px",
      },
      WebsiteID: {
        type: String,
        reqired: true,
      },
    },
    data() {
      return {
        treeData: [],
        treeLoading: false,
        treeBindRef: "tree",
        treeTitle: "组织机构",
        defaultProps: {
          children: "children",
          label: "Name",
        },
      };
    },
    mounted() {
      switch (this.DeptType) {
        case 4:
          this.initGetMyDeptTree();
          break;
        case 5:
          this.initGetALLOrgan();
          break;
      }
    },
    methods: {
      setTreeWidth(width) {
        this.$emit("setTreeWidth", width);
      },
      iconClass(row) {
        return row.data.Type === 2 || row.data.Type === 3 ?
          "icon-biaoqian" :
          row.data.expanded ?
          "icon-dakai1" :
          "icon-wenjiandai";
      },
      initWebsitDeptTree() {
        const that = this;
        getWebSiteDeptTree({
          WebsiteID: this.WebsiteID
        }).then((res) => {
          if (res.Code === 200) {
            that.deptData = res.Data;
          } else {
            this.deptData = [];
          }
        });
      },
      initGetMyDeptTree() {
        const that = this;
        that.treeLoading = true;
        GetAuthOrgan().then((res) => {
          if (res.Code === 200) {
            that.treeData = res.Data;
            if (that.treeData.length == 0) {
              that.treeLoading = false;
              return false;
            }
            that.$nextTick(() => {
              that.$emit("nodeClick", that.treeData[0]);
              that.$refs[this.treeBindRef].setCurrentKey(that.treeData[0].ID);
            });
          } else {
            this.treeData = [];
          }
          that.treeLoading = false;
        });
      },
      initGetALLOrgan() {
        const that = this;
        that.treeLoading = true;
        GetALLOrgan().then((res) => {
          if (res.Code === 200) {
            that.treeData = res.Data;
            if (that.treeData.length == 0) {
              that.treeLoading = false;
              return false;
            }
            that.$nextTick(() => {
              that.$emit("nodeClick", that.treeData[0]);
              that.$refs[this.treeBindRef].setCurrentKey(that.treeData[0].ID);
            });
          } else {
            this.treeData = [];
          }
          that.treeLoading = false;
        });
      },
      nodeClick(obj) {
        this.$emit("nodeClick", obj.obj);
      },
    },
  };

</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/LrOrganization/DeptTree.vue